module.exports = __webpack_public_path__ + "static/media/client-stripe.a4a1d170.png";